import { useArcadeStoreSKUsForService } from '@hooks/useArcadeStore';
import { Button, buttonVariants, Skeleton, Text, VStack } from 'ui_2';
import { ArcadeStoreProduct } from './ArcadeStoreProduct';
import { useSettings } from '@src/data/settings';
import { countries } from 'countries-list';
import { BiLinkAlt, BiLinkExternal } from 'react-icons/bi';

type Props = {
  serviceTitle: string;
  serviceSlug: string;
};
export const ArcadeStoreProducts = ({ serviceSlug, serviceTitle }: Props) => {
  const {
    data: _data,
    error,
    isError,
    isLoading,
  } = useArcadeStoreSKUsForService({
    serviceSlug,
  });

  const { countryCode } = useSettings();

  const data = _data?.filter((product) => product.stock > 0);

  if (isError) {
    return (
      <VStack className='w-full items-center'>
        <Text>Error loading data for {serviceTitle}</Text>
        {error && <Text>{error.message}</Text>}
      </VStack>
    );
  } else if (isLoading) {
    return (
      <div className='grid grid-cols-2 gap-8 md:grid-cols-3'>
        {[...Array(6).keys()].map((_, ix) => (
          <Skeleton
            className='h-[211px] w-[155px] md:h-[246px] md:w-[190px] lg:h-[291px] lg:w-[235px]'
            delay={ix}
            key={ix}
          />
        ))}
      </div>
    );
  } else if (data?.length === 0) {
    return (
      <VStack className='w-full items-center gap-4'>
        <Text>
          No in-stock items for {serviceTitle}
          {countryCode === 'global' || countryCode === undefined
            ? ''
            : ` in ${countries[countryCode].name}`}{' '}
          at the moment. Earn up to $100/month for stocking the arcade store.
          Join our discord if you’re interested in becoming an arcade architect!
        </Text>
        <a
          className={buttonVariants({ className: 'items-center gap-2' })}
          href='https://discord.gg/puzzlearcade'
          target='_blank'
        >
          Join Puzzle Arcade Discord
          <BiLinkExternal />
        </a>
      </VStack>
    );
  } else {
    return (
      <div className='grid grid-cols-2 gap-8 pb-8 xs:grid-cols-3'>
        {data?.map((sku, ix) => (
          <ArcadeStoreProduct sku={sku} service={sku.service} key={ix} />
        ))}
      </div>
    );
  }
};
